import React from "react";
import { useTranslations } from "../../utils";
import { ModalConfirmation } from "@adsk/alloy-react-modal";
export var CancelConfirmation = function (_a) {
    var open = _a.open, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var T = useTranslations().T;
    return (React.createElement(ModalConfirmation, { open: open, "data-testid": "CreateTemplateModal.CancelConfirmationModal", title: T.translate("createTemplateModal.cancelConfirmationModalTitle"), message: T.translate("createTemplateModal.cancelConfirmationModalBody"), onClose: onClose, onConfirm: onConfirm }));
};
